import React from 'react';
import { motion } from 'framer-motion';
import type { BookingConfirmationProps } from './types';

const BookingConfirmation: React.FC<BookingConfirmationProps> = ({ onReturnHome }) => {
  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.9 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.5 }}
      className="max-w-2xl mx-auto text-center"
    >
      <div className="bg-white dark:bg-[#252527] rounded-2xl shadow-xl p-12">
        {/* Animated Icon Container */}
        <motion.div
          initial={{ scale: 0, rotate: -180 }}
          animate={{ scale: 1, rotate: 0 }}
          transition={{
            type: "spring",
            stiffness: 200,
            damping: 15,
            delay: 0.2
          }}
          className="w-20 h-20 bg-green-100 dark:bg-green-900 rounded-full flex items-center justify-center mx-auto mb-6"
        >
          <motion.span
            initial={{ scale: 0 }}
            animate={{ scale: 1 }}
            transition={{
              type: "spring",
              stiffness: 300,
              damping: 10,
              delay: 0.4
            }}
            className="material-symbols-outlined text-green-600 dark:text-green-400 text-5xl"
          >
            check_circle
          </motion.span>
        </motion.div>

        {/* Animated Title */}
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.5, duration: 0.5 }}
          className="text-3xl font-bold text-gray-900 dark:text-white mb-4"
        >
          Booking Confirmed!
        </motion.h2>

        {/* Animated Description */}
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.6, duration: 0.5 }}
          className="text-gray-600 dark:text-gray-400 mb-8"
        >
          Your appointment has been successfully booked. We've sent a confirmation email to your inbox.
        </motion.p>

        {/* Animated Button */}
        <motion.button
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.7, duration: 0.5 }}
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          onClick={onReturnHome}
          className="py-3 px-8 bg-primary text-white rounded-lg hover:bg-primary/90 transition-colors font-semibold"
        >
          Return to Home
        </motion.button>
      </div>
    </motion.div>
  );
};

export default BookingConfirmation;
